module.exports = __webpack_public_path__ + "static/vwhead-regular-735a917617aa1acc7bd46022662d14fa.woff2";